<template>
  <div class="sign">
    <div>
      <div class="sign-tips">请在下方空白处签名</div>
      <div class="sign-box">
        <div class="user-name">
          {{ signTitle }}
        </div>
        <!-- 使用这个签名组件 -->
        <vue-esign ref="esign" class="mySign" :width="800" :height="400" :isCrop="isCrop" :lineWidth="lineWidth"
          :lineColor="lineColor" :bgColor="bgColor" />
        <div class="dialog-footer">
          <van-button class="sign-btn" @click="handleReset" type="warning">重写</van-button>
          <van-button class="sign-btn" @click="handleGenerate" type="primary">签字完成</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Toast } from "vant";
export default {
  name: "SignName",
  data() {
    return {
      lineWidth: 6, // 画笔的线条粗细
      lineColor: "#000000", // 画笔的颜色
      bgColor: "#ffffff", // 画布的背景颜色
      resultImg: "", // 最终画布生成的base64图片
      isCrop: true, // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      // userInfo: {},
      // name: "",
      wsUri: "ws://127.0.0.1:29999",//汉王签字版链接
      webSkt: null,
    };
  },
  props: {
    signTitle: {
      type: String,
      default: "",
    },
  },
  created() {
    // this.init()
    // this.name = this.$route.query.name;
  },
  mounted() {
    // this.websopen()
  },
  methods: {
    toMsg(val) {
      this.$alert(val, '提示', {
        confirmButtonText: '确定',
      });
    },
    goBack() {
      this.$router.back();
    },
    // 清空画板
    handleReset() {
      this.$refs.esign.reset();
    },
    // 生成签字图
    handleGenerate() {
      this.$refs.esign
        .generate() // 使用生成器调用把签字的图片转换成为base64图片格式
        .then((res) => {
          this.resultImg = res;
        })
        .catch((err) => {
          // 画布没有签字时会执行这里提示一下
          this.toMsg("请签名")
          return;
        });

      // 在这里向后端发请求把转换后的base64文件传给后端，后端接收以后再转换成图片做静态图片存储
      // 当然也可以把base64转成流文件blob格式的，类似上传给后端这样，具体哪种方式看后端要求
      setTimeout(() => {
        if (this.resultImg == "" || this.resultImg == null) {
          // this.toMsg("请签名")
          return;
        }
        // 这里要使用定时器稍微延后以后就能取到base64数据了，当然也可以再加一个确认按钮，如：确认使用这张base64签名图片
        // 点击确认以后，在其回调函数中，再把base64的签名图片传给后端用于存储
        // console.log('我是签字后的base64图片', this.resultImg);
        // var data = {
        // id: localStorage.getItem("uniqueId"),
        // signature: this.resultImg,
        // };
        // console.log('我是签字后的base64图片', this.resultImg);
        this.$emit('handleGenerate', this.resultImg)
        // this.$rqt.common_saveSignature(data).then((res) => {
        //   // Toast.clear();
        //   if (res.code == 200) {
        //     var regorg = localStorage.getItem("regorg");
        //     if (regorg != '370705') {
        //       this.$router.push({
        //         path: "/ggws/licence",
        //       });
        //     } else {
        //       this.$router.push({
        //         path: "/mail",
        //         query: {
        //           goal: 'license',
        //           path: "/ggws/licence"
        //         }
        //       });
        //     }
        //   } else {
        //     // Toast.fail("请签名");
        //   }
        // });
      }, 200);
    },
    // 建立websocket链接
    websopen() {
      this.webSkt = new WebSocket(this.wsUri);
      this.webSkt.onopen = (evt) => {
        console.log('汉王签字版就绪', evt);
        setTimeout(() => {
          this.startSign()
        }, 300);
      };
      this.webSkt.onmessage = (evt) => {
        var jsondata = JSON.parse(evt.data);
        this.onMessage(jsondata)
      };
      this.webSkt.onerror = (evt) => {
        console.log('汉王签字板报错', evt);
      };
    },
    // 开始签名
    startSign() {
      var data = {
        "HWPenSign": 'HWInitialize',
        "key": "D9063E7FE567E09E84B00B5ECDE9B3F2",
        "title": "请在签字板上签名",
        "nOrgX": 300,
        "nOrgY": 300,
        "nWidth": 500,
        "nHeight": 300,
        "nImageWidth": -1,
        "nImageHeight": -1,
        "nFingerCap": 0,
        "nConfirmTimeout": 20
      }
      // var data = {
      //   "HWPenSign": "HWInitialize",
      //   "key": "D9063E7FE567E09E84B00B5ECDE9B3F2",
      //   "title": "请在签字板上签名",
      //   "showDialog": 1,
      //   "nOrgX": -1,
      //   "nOrgY": -1,
      //   "nWidth": 1000,
      //   "nHeight": 600,
      //   "nButtonHeight": 60,
      //   "nImageWidth": 250,
      //   "nImageHeight": 150,
      //   "nFingerCap": 0,
      //   "nConfirmTimeout": 30
      // }
      this.doSend(JSON.stringify(data));
    },
    // 发送信息
    doSend(message) {
      this.webSkt.send(message);
    },
    // 接收信息
    onMessage(jsondata) {
      // console.log('返回信息', jsondata);
      if (jsondata.HWPenSign == "HWGetSign" && jsondata.msgID == "0") {
        this.resultImg = jsondata.message
        var data = {
          id: localStorage.getItem("uniqueId"),
          signature: this.resultImg,
        };
        // this.$rqt.common_saveSignature(data).then((res) => {
        //   // Toast.clear();
        //   if (res.code == 200) {
        //     var regorg = localStorage.getItem("regorg");
        //     if (regorg != '370705') {
        //       this.$router.push({
        //         path: "/ggws/licence",
        //       });
        //     } else {
        //       this.$router.push({
        //         path: "/mail",
        //         query: {
        //           goal: 'license',
        //           path: "/ggws/licence"
        //         }
        //       });
        //     }
        //   } else {
        //     // Toast.fail("请签名");
        //   }
        // });
      }
    },
  },
};
</script>
<style scoped>
.sign {
  width: 100%;
  /* height: 100vh; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-name {
  width: 100%;
  height: 10%;
  padding-left: 2.5rem;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
}

.user-name img {
  width: 2rem;
  margin-right: 20px;
}

.sign-box {
  /* width: 100%; */
  /* height: 100vh; */
  /* width: 1000px; */
  width: 90%;
  background-color: #ffffff;
  /* background-color: #822929; */
  margin: auto;
}

.dialog-footer {
  display: flex;
  flex-direction: row-reverse;
}

.sign-btn {
  margin: 0 10px 5px;
  font-size: 22px;
  /* font-weight: 800; */
}

.sign-tips {
  font-weight: 800;
  text-align: center;
  font-size: 22px;
  margin-bottom: 10px;
}
</style>
